import { useState, useContext } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { PageTitle } from '../../../../_metronic/layout/core';
import * as Utilities from '../../../Components/Utils/Utils';
import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import Modal from 'react-bootstrap/Modal';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { registerLocale } from 'react-datepicker';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import ActualizarCierreVentas from "./ActualizarCierreVentas";
import AgTable from '../../../Components/Table/AgTable';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

function ConsultarCierreVentas({ setViewCierreVentas, title, unidadEconomica, nombreLocatario, numContrato }) {

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();

    const [date1, setDate1] = useState(new Date(year, month, 1));

    const [date2, setDate2] = useState(new Date());

    const [dateRange, setDateRange] = useState([date1, date2]);
    const [startDate, endDate] = dateRange;
    let dateFormated1 = startDate ? ("0" + (startDate.getDate())).slice(-2) + "/" + ("0" + (startDate.getMonth() + 1)).slice(-2) + "/" + startDate.getFullYear() : null;
    let dateFormated2 = endDate ? ("0" + (endDate.getDate())).slice(-2) + "/" + ("0" + (endDate.getMonth() + 1)).slice(-2) + "/" + endDate.getFullYear() : null;

    registerLocale('es', es);

    const tokenn = useGetToken();
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);


    const [abirActualizarCierreVentas, setAbirActualizarCierreVentas] = useState(false);
    const [guardadoExitoso, setGuardadoExitoso] = useState(false);

    const [auxData, setAuxData] = useState({
        "totalVentas": null
    });

    const [cierreVentasCurrentEdit, setCierreVentasCurrentEdit] = useState(null);

    const [value, onChange] = useState([new Date(year, month, 1), new Date()]);

    let header = [
        {
            headerName: 'Nombre Completo',
            field: 'nombreCompleto',
            type: 'rightAligned',
        },
        {
            headerName: 'Registro',
            field: 'registroFecha',
        },
        {
            headerName: 'Suministro',
            field: 'suministro',

        },
        {
            headerName: 'Ventas (S/)',
            field: 'ventasValor',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventasValor, true)}</>
            )
        },
        {
            headerName: 'Transacciones',
            field: 'numeroTransacciones',
            type: 'rightAligned',
        },
        {
            headerName: 'Editar',
            cellRenderer: (props) => (
                <button className="btn btn-light btn-active-light-primary btn-sm" onClick={() => {
                    setCierreVentasCurrentEdit(props.data);
                    setAbirActualizarCierreVentas(true);
                }
                } >
                    <i className="fi-rr-interactive"></i>
                </button >
            )
        }
    ];

    function onAfterGuardar(action) {
        setAbirActualizarCierreVentas(false);
        if (action === true) setGuardadoExitoso(true);
    }
    function guardadoExistosoModal() {
        setGuardadoExitoso(false)
        window.location.reload(false);
    }

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.LOCATARIOS]} >
                <PageTitle>
                    {title}

                </PageTitle>


                <div className="d-flex flex-wrap flex-stack mb-6">

                    <h3 className='fw-bolder my-2'>Locatario: {nombreLocatario}</h3>

                    <div className='d-flex flex-wrap my-2' >
                        <button className="nav-link btn btn-sm btn-color-muted btn-active btn-active-secondary fw-bolder px-4 me-1" onClick={
                            () => setViewCierreVentas(false)
                        } >
                            <i className="fi-rr-arrow-small-left"></i> Volver a Lista de Locatarios
                        </button >
                    </div>
                </div>

                {abirActualizarCierreVentas &&
                    <ActualizarCierreVentas cierreVentas={cierreVentasCurrentEdit} setSmShow={onAfterGuardar}></ActualizarCierreVentas>}
                <div className="card">
                    <div className="card-body pt-6">
                        <div className="d-flex flex-wrap flex-stack mb-6">
                            <div className=' my-2' style={{ minWidth: "220px" }}>
                                <h3 className='text-dark text-hover-primary fw-bolder fs-3'>Total Ventas</h3>
                                <div className='fw-bolder fs-3 text-primary'>S/ {Utilities.comillasFix(auxData.totalVentas)}</div>
                            </div>
                            <div className='d-flex flex-wrap my-2 flex-column'>
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Rango de Fecha:</div>
                                <DateRangePicker
                                    onChange={(dateRange) => {
                                        onChange(dateRange)
                                        dateRange &&
                                            setDateRange(dateRange);
                                    }}
                                    value={value}
                                    format="dd/MM/y"
                                    className="form-control form-control-transparent pe-5 fit-content-width"
                                    minDate={new Date(dateFormated1, 0, 1)}
                                    locale="es"
                                />
                            </div>
                        </div>
                        <AgTable
                            idContent={"Cierre de Ventas -" + unidadEconomica.label + " - " + nombreLocatario + " - " + numContrato + " - " + dateFormated1 + " - " + dateFormated2}
                            apiService={Api.CierreVentasPorLocatario}
                            setAuxData={setAuxData}
                            header={header}
                            titleExcel={"Cierre de Ventas " + unidadEconomica.label + " " + nombreLocatario + " " + numContrato + " " + dateFormated1 + " " + dateFormated2}
                            conditions={dateFormated1 != null && dateFormated2 != null}
                            args={{ numContrato: numContrato, fechaInicial: dateFormated1, fechaFinal: dateFormated2, token: tokenn }}
                            hideFilter={false}
                            paginationPageSize={8}
                            rowHeight={40}
                            isDownload={true}
                        />
                    </div>
                </div>


                <Modal
                    size="sm"
                    show={guardadoExitoso}
                    onHide={() => setGuardadoExitoso(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                            Guardado Exitoso
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer style={{ margin: 'auto' }}>
                        <button type="button" className="btn btn-primary" onClick={guardadoExistosoModal}>
                            Aceptar
                        </button>
                    </Modal.Footer>
                </Modal>
            </PermissionsGate>
        </>
    )
}

export default ConsultarCierreVentas;
